<div class="single-selection-entity">

    <!-- SINGLE SHIPPER -->
    @if (hasSingleCustomer) {
    <span kendoTooltip
          [title]="getFilterTooltip(filterCollection.customers[0])">
        <button class="btn btn-outline-primary"
                type="button"
                [class.active]="isSelected(filterCollection.customers[0])"
                (click)="select(filterCollection.customers[0])">
            {{ customerToggleText }}
        </button>
    </span>
    }

    <!-- MULTIPLE SHIPPERS -->
    @if (hasMultipleCustomers) {
    <div class="shipper-composite"
         [class.selected]="isCustomerSelected"
         kendoTooltip
         [title]="getFilterTooltip(filterCollection.customers[0])">
        <kendo-dropdownbutton [data]="filterCollection.customers"
                              textField="name"
                              (itemClick)="select($event)"
                              class="shipper-chevron"
                              [class.selected]="isCustomerSelected"
                              [popupSettings]="{ popupClass: 'shipper-popup' }">
            <svg class="arrow" width="12" height="7" aria-hidden="true" focusable="false">
                <use href="assets/svg/menu-arrows.svg#arrow-down"></use>
            </svg>
            <ng-template kendoDropDownButtonItemTemplate let-item>
                <span class="ddb-item"
                      [class.selected]="isSelected(item)">{{ item.name }}</span>
            </ng-template>
        </kendo-dropdownbutton>
        <button type="button"
                class="shipper-text-btn"
                [class.active]="isCustomerSelected"
                [disabled]="!isCustomerSelected">
            {{ customerToggleText }}
        </button>
    </div>
    }

    <!-- SINGLE ASSOCIATION -->
    @if (hasSingleAssociation) {
    <span kendoTooltip
          [title]="getFilterTooltip(filterCollection.associations[0])">
        <button class="btn btn-outline-primary"
                type="button"
                [class.active]="isSelected(filterCollection.associations[0])"
                (click)="select(filterCollection.associations[0])">
            {{ associationToggleText }}
        </button>
    </span>
    }

    <!-- MULTIPLE ASSOCIATIONS -->
    @if (hasMultipleAssociations) {
    <div class="association-composite"
         [class.selected]="isAssociationSelected"
         kendoTooltip
         [title]="getFilterTooltip(filterCollection.associations[0])">
        <kendo-dropdownbutton [data]="filterCollection.associations"
                              textField="name"
                              (itemClick)="select($event)"
                              class="association-chevron"
                              [class.selected]="isAssociationSelected"
                              [popupSettings]="{ popupClass: 'association-popup' }">
            <svg class="arrow" width="12" height="7" aria-hidden="true" focusable="false">
                <use href="assets/svg/menu-arrows.svg#arrow-down"></use>
            </svg>
            <ng-template kendoDropDownButtonItemTemplate let-item>
                <span class="ddb-item"
                      [class.selected]="isSelected(item)">{{ item.name }}</span>
            </ng-template>
        </kendo-dropdownbutton>
        <button type="button"
                class="association-text-btn"
                [class.active]="isAssociationSelected"
                [disabled]="!isAssociationSelected">
            {{ associationToggleText }}
        </button>
    </div>
    }

    <!-- NETWORK BUTTON -->
    @if (filterCollection.hasNetwork) {
    <span kendoTooltip
          [title]="getFilterTooltip(filterCollection.network!)">
        <button class="btn btn-outline-primary"
                type="button"
                [class.active]="isSelected(filterCollection.network!)"
                (click)="select(filterCollection.network!)">
            Network Data
        </button>
    </span>
    }

</div>
